import { createContext, useContext } from "react";

export type NuggetsType = {
  id: string;
  onClick?: (value: string) => void;
};

type initialStateType = {
  activeIndex: number;
  startIndex: number;
  slicedNuggets: NuggetsType[];
};

export const initialState = {
  activeIndex: 0,
  startIndex: 0,
  slicedNuggets: [],
};

export enum ChickenNuggetsActionKeys {
  ActiveIndex = "activeIndex",
  StartIndex = "startIndex",
  SlicedNuggets = "slicedNuggets",
}

type ChickenNuggetsActionType =
  | { type: ChickenNuggetsActionKeys.ActiveIndex; payload: number }
  | { type: ChickenNuggetsActionKeys.StartIndex; payload: number }
  | { type: ChickenNuggetsActionKeys.SlicedNuggets; payload: NuggetsType[] };

export function reducer(
  state: initialStateType,
  action: ChickenNuggetsActionType
): initialStateType {
  const { type, payload } = action;
  return { ...state, [type]: payload };
}

type ChickenNuggetsContextType = {
  nuggets: NuggetsType[];
  state: initialStateType;
  dispatch: React.Dispatch<ChickenNuggetsActionType>;
};

export const ChickenNuggetsContext = createContext<ChickenNuggetsContextType>({
  nuggets: [],
  state: initialState,
  dispatch: () => {},
});

export const useChickenNuggetsContext = () => useContext(ChickenNuggetsContext);
